import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //缓存一下需要暂存的页面
    keepArr: ["GradeLearning"],
    //请求错误提示
    errApi: {
      text: "错误内容",
      type: false,
    },
    //错误弹框
    errBox: {
      text: "错误内容",
      type: false,
    },
    worngData: {},
    token: "",
    schoolId: "",
    examData: {},
  },
  mutations: {
    setToken(state, val) {
      state.token = val;
    },
    setSchoolId(state, val) {
      state.schoolId = val;
    },
    setWorngData(state, val) {
      state.worngData = val;
    },
    setKeepArr(state, val) {
      state.keepArr.push(val);
    },
    delKeepArr(state, val) {
      if (!val) {
        state.keepArr = [];
      } else {
        state.keepArr.splice(state.keepArr.indexOf(val), 1);
      }
    },
    setErrApi(state, val) {
      state.errApi.type = val.type;
      if (val.text) {
        state.errApi.text = val.text;
      }
      // console.log(val);
    },
    setErrBox(state, val) {
      state.errBox.type = val.type;
      if (val.text) {
        state.errBox.text = val.text;
      }
      // state.errBox.type = val;
    },
    setExamScoreData(state, val) {
      state.examData = val;
    },
  },
  getters: {
    // setToken(state, val){
    //   state.token = val;
    // },
    // setSchoolId(state, val){
    //   state.setSchoolId = val;
    // },
    getToken(state) {
      return state.token;
    },
    getSchoolId(state) {
      return state.schoolId;
    },
    getWorngData(state) {
      return state.worngData;
    },
    getHeaderType(state) {
      return state.headerType;
    },
    getKeepArr(state) {
      return state.keepArr;
    },
    getErrApi(state) {
      return state.errApi;
    },
    getErrBox(state) {
      return state.errBox;
    },
    getExamScoreData(state) {
      return state.examData;
    },
  },
  actions: {},
  modules: {},
});
